import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import utils from '../../js/utils.js';
import 'moment-timezone';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';
import axios from 'axios';


export default {
    name: 'previewBooking',
    components:{
       headerComponent,
       FooterComponent,
       LoaderPopover,
       CustPopover

    },
    data(){
        return {
            mobile_view : false,
            total_sum: 0,
            all_bookings:[],
            store_data : [],
            reschedule_flag:false,
            footer_content:'',
            footer_color:'',
            store_mobile : JSON.parse(this.$session.get('store_details')).store_mobile,
            slots_not_available : false,
            unpaid_booking_details:[],
            product_details : [],
            booking_details : {},
            product_details_array:[]
        }
    },
    // computed:{
    //     sortedJson: function() {
    //         return this.all_bookings.sort((t1,t2) => t1.slot_date < t2.slot_date ? -1 : 1);
    //     },
    // },
    mounted(){   
        if(this.$session.get('cust_details') && !this.$session.get('service_obj')){
            this.$router.push('/mybookings');
        }     
        this.get_Customer_Store_Details();
        this.get_Customer_Booking_Details();
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
    },  
    methods:{
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },
        get_Customer_Booking_Details(){

            this.$store.state.loader_popup = true;

            var service_details = JSON.parse(this.$session.get('service_obj'));

            if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
                this.product_details  = JSON.parse(this.$session.get('product_obj'));
            }
            
            if(this.$session.get('service_obj') && JSON.parse(this.$session.get('service_obj')).length > 0){
                service_details.forEach(service_bookings => {

                    let created_date =  service_bookings.slot_date;
                    
                    if(!(created_date in this.all_bookings)){
                        this.all_bookings[created_date] = {};
                        this.all_bookings[created_date]["service_bookings"] = [];
                    }
                    this.all_bookings[created_date]["service_bookings"].push(service_bookings);
                });

                this.all_bookings = Object.keys(this.all_bookings).sort().reduce(
                    (obj, key) => { 
                    obj[key] = this.all_bookings[key]; 
                    return obj;
                    }, 
                    {}
                );
           

                for (let [date,date_bookings] of Object.entries(this.all_bookings)) {
                    
                    console.log(date)
                
                    this.sort_by_key(date_bookings.service_bookings,"slot_start_time"); 

                    date_bookings.service_bookings.forEach(bookings => {

                        if(bookings.book_discount_full_amount >= 0){
                            this.total_sum  +=  parseFloat(bookings.book_discount_full_amount);
                        }else{
                            this.total_sum  +=  parseFloat(bookings.serv_saleprice);
                        } 
                        
                    });
                    
                }

                this.product_details.forEach(product => {
                    if(product.product_discount_full_amount >= 0){
                        this.total_sum  +=  parseFloat(product.product_discount_full_amount) * (product.quantity_selected);
                    }else{
                        this.total_sum  += parseFloat(product.product_sale_price) * (product.quantity_selected);
                    } 

                });

                this.reschedule_flag = service_details.some(serv_obj => Object.keys(serv_obj).includes('edit_flag'));

                if(this.reschedule_flag){
                    this.footer_content = "Reschedule";
                    this.footer_color =  "blue_bg";

                }else{
                    this.footer_content= "Proceed to pay";
                    this.footer_color =  "green_bg";
                }

            } 

            this.$store.state.loader_popup = false;
        },
        sort_by_key(array, key)
        {
            return array.sort(function(a, b)
            {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },
        async get_Customer_Store_Details(){
            await this.$store.dispatch('getStoreDetails',[this.$store.state.api,this.$store.state.store_url_name])
            this.$ga.page(this.$router);
            if(Object.keys(this.$store.state.cust_store_data).length > 0){
                this.store_data = this.$store.state.cust_store_data;
            }else{
                this.store_data = [];
            }
        },
        edit_cart(){
            let session_services = JSON.parse(this.$session.get('service_obj'));
            this.$store.state.slots_available_details.slots.forEach((slot_available,index)=>{
                if(slot_available.is_available == 0){
                    delete session_services[index].slot_start_time ;
                    delete session_services[index].slot_end_time;
                    delete session_services[index].slot_date;
                }
            })
            this.$session.set('service_obj', JSON.stringify(session_services));

            this.$router.push('/cart')
        },

        remove_slots_available_popup(){
            this.slots_not_available = false;
        },

        async save_customer(){
            let service_details =  JSON.parse(this.$session.get('service_obj'));
            
                this.booking_details = {
                "book_country_isd_code": service_details[0].cust_country_isd_code,
                "book_created_by"      : service_details[0].cust_id,
                "book_email"           : service_details[0].cust_email,
                "book_first_name"      : service_details[0].book_first_name,
                "book_last_name"       : service_details[0].book_last_name,
                "book_mobile"          : service_details[0].cust_mobile,
                "book_updated_by"      : service_details[0].cust_id,
                "booked_through"       : this.Constants.BOOKED_THROUGH_CUSTOMER,
                "booking_type"         : this.Constants.BOOKING_TYPE_RESCHEDULE_BOOKING,
                "cust_id"              : service_details[0].cust_id,
                "email_send"           : true,
                "save_unpaid_status"   : this.Constants.EDIT_FLAG,
                "product_details"      : this.product_details_array,
                "service_details"      : [{
                    "book_deposit"     : service_details[0].serv_deposit,
                    "book_discount_full_amount" : service_details[0].book_discount_full_amount,
                    "book_discount_deposit_amount": service_details[0].book_discount_deposit_amount,
                    "book_duration"    : service_details[0].serv_defdur,
                    "book_end_date"    : service_details[0].slot_date,
                    "book_end_time"    : service_details[0].slot_end_time,
                    "book_fullamount"  : service_details[0].serv_saleprice,
                    "book_id"          : service_details[0].booking_id,
                    "book_oldbookid"   : service_details[0].book_oldbookid,
                    "book_staff_note"  : service_details[0].staff_note,
                    "book_start_date"  : service_details[0].slot_date,
                    "book_start_time"  : service_details[0].slot_start_time,
                    "multi_service_book_id": service_details[0].multi_service_book_id,
                    "serv_cat_id"      : service_details[0].serv_cat_id,
                    "serv_id"          : service_details[0].serv_id,
                    "user_id"          : service_details[0].staff_id,
                    "user_staff_type_id": service_details[0].user_perm_staff_type
                }],
                "sms_send"              : true,
                "store_id"              : service_details[0].store_id,
                "updated_through"       : this.Constants.UPDATED_THROUGH_CUSTOMER
            }

            if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
                let product_obj     =  JSON.parse(this.$session.get('product_obj'));

                product_obj.forEach((product,index) => {
                let prod_obj= {
                    "booking_product_id":product.booking_product_id,
                    "product_id": product.product_id,
                    "product_name":product.product_name,
                    "product_sku":product.product_sku,
                    "product_barcode":product.product_barcode,
                    "product_image_url":product.product_default_image.product_image_url,
                    "product_thumbnail_url":product.product_default_image.product_thumbnail_url,
                    "product_date": service_details[0].slot_date,
                    "product_quantity": product.quantity_selected, 
                    "old_quantity":product.old_quantity,
                    "remaining_product_quantity":this.$store.state.slots_available_details.products[index].available_quantity,
                    "total_product_quantity":this.$store.state.slots_available_details.products[index].available_quantity,
                    "product_full_amount": product.product_sale_price, 
                    "product_book_status": this.Constants.STATUS_BOOKED, 
                    "product_book_notes": "",
                    "booking_old_product_id":product.booking_old_product_id
                }
                this.product_details_array.push(prod_obj);
                    
                });

                
            }

            this.booking_details['product_details'] = this.product_details_array;


            await axios.post( this.$store.state.api+ `booking/insert`,
                this.booking_details
            ).then(response => {
                var  book_details_json_obj = {
                    "booking_id": response.data.result.bookings[0].book_id,
                    "multi_service_book_id": response.data.result.bookings[0].multi_book_id,
                    "type":  "service", 
                };
                this.unpaid_booking_details.push(book_details_json_obj)
                this.$session.set('unpaid_booking_details', JSON.stringify(this.unpaid_booking_details));
                this.$router.push('/bookingsuccess');
            })
    
           
        },

        async proceed_payment(){
            this.$session.set('preview_booking_flag', true);
            let session_services = JSON.parse(this.$session.get('service_obj'));
            if(session_services.some(cart_serv => Object.keys(cart_serv).includes('edit_flag'))){
                this.$store.state.loader_popup = true;
                let slots = [];
                let products = [];
                session_services.forEach(function(serv){
                    slots.push(serv);
                })

                if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
                    let session_products     =  JSON.parse(this.$session.get('product_obj'));
                    session_products.forEach(function(product) {
                        let product_obj = {
                            "product_id"        : product.product_id,
                            "selected_quantity" : product.quantity_selected
                        }
                        products.push(product_obj);
                    });    
                }

                await this.$store.dispatch('slotsAvailabilityCheck',[this.$store.state.api,slots,products,1]);
                this.$store.state.slots_available_details.slots.forEach(cart_serv => {
                    if(cart_serv.is_available == 0){
                        this.$store.state.loader_popup = false;
                        this.slots_not_available = true;
                    }
                });
                
                if(this.$session.get('product_obj') && JSON.parse(this.$session.get('product_obj')).length > 0){
                    this.$store.state.slots_available_details.products.forEach(cart_product => {
                        if(cart_product.is_available == 0){
                            this.$store.state.loader_popup = false;
                            this.slots_not_available = true;
                        }
                    });
                }

                if(!this.slots_not_available){
                    await this.save_customer();
                }
            }else{
                if(this.$session.get('cust_details'))
                {
                    this.$router.push('/terms');
                }
                else{
                    this.$router.push('/custlogin'); 
                }
            }
          
        }
    },
    filters: {
        human_date_format: function (date,timezone,date_format) {
            return utils.human_date_format(date,timezone,date_format)
        },
        time_12hrs_format:function(time,time_format){
            return utils.time_12hrs_format(time,time_format)
        }
    }
}